export class LanguageProficiencyProofs {


	static readonly IELTS: LanguageProficiencyProof = {
		name: "IELTS",
		requiresRlwsGrade: true,
		requiresInput: true,
		hint: "Score between 1.0 and 9.0 (e.g., 7.5)"
	};

	static readonly TOEFL_IBT: LanguageProficiencyProof = {
		name: "TOEFL iBT (Internet Based Test)",
		shortcut: "TOEFL iBT",
		requiresRlwsGrade: true,
		requiresInput: true,
		hint: "Score between 0 and 120"
	};

	static readonly TOEFL_ITP: LanguageProficiencyProof = {
		name: "TOEFL ITP Level 1",
		requiresRlwsGrade: true,
		requiresInput: true,
		hint: "Score between 310 and 677 (e.g., 543)"
	};

	static readonly CAMBRIDGE_PET: LanguageProficiencyProof = {
		name: "Cambridge Preliminary English Test",
		requiresRlwsGrade: false,
		requiresInput: true,
		hint: "Score between 120 and 170"
	};

	static readonly CAMBRIDGE_FCE: LanguageProficiencyProof = {
		name: "Cambridge First Certificate in English (FCE)",
		requiresRlwsGrade: false,
		requiresInput: true,
		hint: "Score between 140 and 190"
	};

	static readonly CAMBRIDGE_BEC_VANTAGE: LanguageProficiencyProof = {
		name: "Cambridge English: Business Vantage (BEC Vantage)",
		requiresRlwsGrade: false,
		requiresInput: true,
		hint: ""
	};

	static readonly CAMBRIDGE_ILEC: LanguageProficiencyProof = {
		name: "Cambridge English: Legal (ILEC)",
		requiresRlwsGrade: false,
		requiresInput: true,
		hint: ""
	};

	static readonly CAMBRIDGE_ICFE: LanguageProficiencyProof = {
		name: "Cambridge English: Financial (ICFE)",
		requiresRlwsGrade: false,
		requiresInput: true,
		hint: ""
	};

	static readonly CAMBRIDGE_IGCSE: LanguageProficiencyProof = {
		name: "Cambridge IGCSE",
		requiresRlwsGrade: false,
		requiresInput: true,
		hint: ""
	};

	static readonly PTE_ACADEMIC: LanguageProficiencyProof = {
		name: "Pearson PTE Academic",
		requiresRlwsGrade: false,
		requiresInput: true,
		hint: "Enter a score between 10 and 90 (e.g., 59)"
	};

	static readonly TOEIC: LanguageProficiencyProof = {
		name: "TOEIC",
		requiresRlwsGrade: false,
		requiresInput: true,
		hint: "Enter as 'Listening and Reading: X, Speaking: Y, Writing: Z'"
	};

	static readonly TELC_B2: LanguageProficiencyProof = {
		name: "telc B2",
		requiresRlwsGrade: false,
		requiresInput: false,
		hint: "Upload proof"
	};

	static readonly UNICERT_II: LanguageProficiencyProof = {
		name: "UNIcert II",
		requiresRlwsGrade: false,
		requiresInput: false,
		hint: "Upload proof"
	};

	static readonly ENGLISH_STUDIES: LanguageProficiencyProof = {
		name: "Study in English Studies or American Studies",
		shortcut: "BA ENG",
		requiresRlwsGrade: false,
		requiresInput: false,
		hint: "Upload proof"

	};

	static readonly DEGREE_ENGLISH: LanguageProficiencyProof = {
		name: "Completed degree with English as the language of instruction",
		shortcut: "Uspr BA",
		requiresRlwsGrade: false,
		requiresInput: false,
		hint: "Upload proof"
	};

	static readonly PROFESSIONAL_TRANSLATOR: LanguageProficiencyProof = {
		name: "Proof of professional qualification as interpreter/translator",
		requiresRlwsGrade: false,
		requiresInput: false,
		hint: "Upload proof"
	};

	static getAllProofs() {
		return Object.values(LanguageProficiencyProofs);
	}

}

export interface LanguageProficiencyProof {
	name: string;
	requiresRlwsGrade: boolean;
	requiresInput: boolean;
	hint: string
	shortcut?: string;
}
